/* tslint:disable */
/* eslint-disable */
/**
 * OMS API
 * The documentation for the Order Management System (OMS) backend API.
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

// @ts-ignore
import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SwitchContextRequest
 */
export interface SwitchContextRequest {
    /**
     * 
     * @type {string}
     * @memberof SwitchContextRequest
     */
    organizationId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SwitchContextRequest
     */
    supplierId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SwitchContextRequest
     */
    retailerId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SwitchContextRequest
     */
    storeId?: string | null;
}

/**
 * Check if a given object implements the SwitchContextRequest interface.
 */
// @ts-ignore
export function instanceOfSwitchContextRequest(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

// @ts-ignore
export function SwitchContextRequestFromJSON(json: any): SwitchContextRequest {
    return SwitchContextRequestFromJSONTyped(json, false);
}

// @ts-ignore
export function SwitchContextRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SwitchContextRequest {
// @ts-ignore
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'organizationId': !exists(json, 'organization_id') ? undefined : json['organization_id'],
        'supplierId': !exists(json, 'supplier_id') ? undefined : json['supplier_id'],
        'retailerId': !exists(json, 'retailer_id') ? undefined : json['retailer_id'],
        'storeId': !exists(json, 'store_id') ? undefined : json['store_id'],
    };
}

// @ts-ignore
export function SwitchContextRequestToJSON(value?: SwitchContextRequest | null): any {
// @ts-ignore
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'organization_id': value.organizationId,
        'supplier_id': value.supplierId,
        'retailer_id': value.retailerId,
        'store_id': value.storeId,
    };
}

